module.exports = "<div class=\"container\">\n  <p></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/footer.html
// module id = 97
// module chunks = 0